
<section class="ui_cardinfo">
  <div class="cardinfo">
    <div class="cardinfo_test cardinfo_pic">
      <div class="cardinfo_pic_box">
        <img :src="require(`@/assets/device/${imgPath}`)">
      </div>
      
    </div>
    <div class="cardinfo_test cardinfo_info">
      <slot :name="slotName"  :data="dataInfo"></slot>
    </div>
    <div class="cardinfo_test cardinfo_btn">
      
      <Button class="btn-inline" type="both" colors="main" @onClick="setCalibration" :text="btn1"></Button>
      <Button class="btn-inline" type="border" @onClick="setUnbind" :text="btn2"></Button>
    </div>
  </div>
</section>

